export const CITIES_HEADER_TITLES = {
	ID: 'ID міста',
	NAME: 'Назва',
	PREFIX: 'Префікс',
	SHOR_PREFIX: 'Скорочення',
	REGION_ID: 'ID регіону',
	REGION_NAME: 'Назва регіону',
};
